import { AlertTriangle, AlertCircle, Info } from "lucide-react";

const riskConfig = {
  Critical: { icon: AlertTriangle, color: "text-red-400", bg: "bg-red-500/10 border-red-500/20", badge: "bg-red-500/20 text-red-300" },
  High: { icon: AlertCircle, color: "text-amber-400", bg: "bg-amber-500/10 border-amber-500/20", badge: "bg-amber-500/20 text-amber-300" },
  Medium: { icon: Info, color: "text-blue-400", bg: "bg-blue-500/10 border-blue-500/20", badge: "bg-blue-500/20 text-blue-300" },
};

export default function StockoutAlerts({ alerts }) {
  return (
    <div className="bg-slate-900/40 border border-slate-800 rounded-2xl p-6" data-testid="stockout-alerts">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-base font-semibold text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>Stock-Out Risk Alerts</h3>
          <p className="text-xs text-slate-500 mt-0.5">{alerts.length} products at risk</p>
        </div>
        <AlertTriangle className="w-5 h-5 text-amber-400" />
      </div>
      <div className="space-y-2 max-h-[280px] overflow-y-auto pr-1">
        {alerts.length === 0 ? (
          <p className="text-sm text-slate-500 text-center py-8">No stock-out risks detected</p>
        ) : alerts.map((a, i) => {
          const cfg = riskConfig[a.risk_level];
          const Icon = cfg.icon;
          return (
            <div key={i} className={`rounded-xl border p-3 ${cfg.bg}`} data-testid={`stockout-alert-${i}`}>
              <div className="flex items-start gap-3">
                <Icon className={`w-4 h-4 mt-0.5 flex-shrink-0 ${cfg.color}`} />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs font-medium text-white truncate">{a.name}</span>
                    <span className={`text-[9px] font-bold uppercase px-1.5 py-0.5 rounded-full ${cfg.badge}`}>{a.risk_level}</span>
                  </div>
                  <div className="flex items-center gap-3 text-[10px] text-slate-400">
                    <span>Stock: {a.current_stock.toLocaleString()}</span>
                    <span>Avg Demand: {a.avg_monthly_demand.toLocaleString()}/mo</span>
                    <span>{a.months_of_stock} mo supply</span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
